import React from 'react';
import { Box, Typography } from '@capitalise/ui-design-system';
import PropTypes from 'prop-types';

export const ErrorCheckbox = ({ error }) => (
  <Box py="xtiny" px="tiny" backgroundColor="danger-50" borderRadius="4px" mb="2xsmall" mr="xsmall">
    <Typography size="caption-12" color="danger">
      {error}
    </Typography>
  </Box>
);

ErrorCheckbox.propTypes = {
  error: PropTypes.string,
};
